import { Link as RouterLink } from 'react-router-dom'
import {
  Avatar,
  Button,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material'

import { LinkIcon } from 'src/assets/icons'
import { useStyles } from './styles'
import { Fragment } from 'react'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { IWhiteLabelBaseWithId } from 'src/types/white-label-partners.type'
import { useSetAccountWlp } from 'src/hooks/accounts/use-account-white-label.hook'
import { useAccount } from 'src/hooks'
import { DEFAULT_LANGUAGE_CODE } from 'src/components/languages/langauges-list/constants'

interface ITableListProps {
  items?: IWhiteLabelBaseWithId[] | void
  accountId: string
}

const TableList = ({ items, accountId }: ITableListProps) => {
  const classes = useStyles()
  const { mutateAsync } = useSetAccountWlp()
  const { data: account } = useAccount(DEFAULT_LANGUAGE_CODE, accountId)

  const handleSelect = (id: string | null) => () => {
    const data = { accountId: accountId, wlpId: id }
    mutateAsync(data)
    // window.location.reload()
  }

  return (
    <TableContainer sx={{ minWidth: '660px' }}>
      <Table>
        <TableBody>
          {items?.map((row) => (
            <Fragment key={row.id}>
              <TableRow className={classes.tableRow}>
                <TableCell>
                  <Avatar alt={row.name} src={row.logo} />
                </TableCell>
                <TableCell>
                  {row.name}
                  {/* {row.journey_link && (
                    <>
                      <br />
                      <Link
                        className={classes.rowUrlLink}
                        target="_blank"
                        component={RouterLink}
                        to={row.journey_link}
                      >
                        <HelperWrapper t="account-form-website-input-label" />
                        <LinkIcon className={classes.urlIcon} />
                      </Link>
                    </>
                  )} */}
                </TableCell>
                <TableCell align="right">
                  {account?.white_label?.id !== row.id ? (
                    <Button
                      type="button"
                      variant="contained"
                      color="secondary"
                      className={classes.impactsLibraryButton}
                      onClick={handleSelect(row.id)}
                    >
                      <HelperWrapper t="select-button-text" />
                    </Button>
                  ) : (
                    <Button
                      type="button"
                      variant="outlined"
                      color="primary"
                      className={classes.impactsLibraryButton}
                      onClick={handleSelect(null)}
                    >
                      <HelperWrapper t="white-label-modal-unassign" />
                    </Button>
                  )}
                </TableCell>
              </TableRow>
              <TableRow className={classes.tableRow}>
                {/* <TableCell colSpan={4}>
                  <TableDescriptionColumn text={row.description} />
                </TableCell> */}
              </TableRow>
            </Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export { TableList }
